import { SearchField } from "../components";
import { TestEvents } from "./components";
import { useSearchParams } from "react-router-dom";

export function TestEventList() {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search") ?? undefined;

  return (
    <>
      <h3 className="mb-2">Test Events</h3>
      <div className="mb-3">
        <SearchField />
      </div>

      <TestEvents filters={{ searchString: search }} expanded={true} allowExpand={false} />
    </>
  );
}
